import styled from "styled-components";
import { position, PositionProps } from "styled-system";

const BAR_HEIGHT = "3px";

export const StyledButton = styled.button`
	cursor: pointer;
	background: none;
	margin: 0;
	padding: 0;
	border: 0;
	width: 20px;
	height: 17px;
	position: relative;

	z-index: 100;
	transition: all 400ms ease-in-out;

	&.HamburgerButton .HamburgerButton__bar:nth-child(1) {
		transition: all 400ms ease-in-out;
		top: 0;
		left: 0;
	}

	&.HamburgerButton .HamburgerButton__bar:nth-child(2) {
		transition: all 400ms ease-in-out;
		top: calc(50% - (${BAR_HEIGHT} / 2));
		left: 0;
	}

	&.HamburgerButton .HamburgerButton__bar:nth-child(3) {
		transition: all 400ms ease-in-out;
		bottom: 0;
		left: 0;
	}

	&.HamburgerButton--open .HamburgerButton__bar:nth-child(1) {
		transform: rotate(-45deg);
		transform-origin: center right;
	}

	&.HamburgerButton--open .HamburgerButton__bar:nth-child(2) {
		opacity: 0;
	}

	&.HamburgerButton--open .HamburgerButton__bar:nth-child(3) {
		transform: rotate(45deg);
		transform-origin: center right;
	}
`;

export const StyledBar = styled.div<PositionProps>`
	position: absolute;
	width: 20px;
	height: ${BAR_HEIGHT};
	background-color: ${({ theme }) => theme.palette.hexForRole("fg_light_1")};
	border-radius: 2px;
	${position}
`;
